// extracted by mini-css-extract-plugin
module.exports = {"all":"e_Y3","accent":"e_Z3"};